import {Checkbox, Form} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import RequiredText from '@/components/RequiredText/RequiredText';

const CheckBoxCmp = ({
  id,
  value,
  label,
  title,
  translate,
  required,
  ...rest
}) => {
  const {t} = useTranslation(translate || 'common');
  
  return (
    <Form.Item
      {...rest}
      name={id}
      label={t(label)}
      valuePropName="checked"
      required={required}
      rules={[{required: required}]}
      noStyle={!title}
      initialValue={value}
      className={classNames({'mb-2': !!rest?.help})}
    >
      <Checkbox className={classNames('mx-0 my-px')} size={'large'}>
        <RequiredText value={t(title)} required={required && !label} className="mb-0"/>
      </Checkbox>
    </Form.Item>
  );
};

CheckBoxCmp.propTypes = {
  id: PropTypes.string,
  value: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  translate: PropTypes.string,
  help: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func
};

CheckBoxCmp.defaultProps = {
  required: true
};

export default memo(CheckBoxCmp);
